export default __webpack_public_path__ + "static/media/settings.389b91e8.png";